import React from 'react';
import { useStoreLocation } from '../../context/StoreLocation';
import Order from './order';
import StaticOrder from './staticOrder';

export default function ItemDetailPage() {
  const { locationInfo } = useStoreLocation();
  const isLocationSelected = locationInfo?.selectedStore?.is_live;
  return isLocationSelected ? <Order /> : <StaticOrder />;
}
